import { jsx } from 'react/jsx-runtime';
import { Svg18Info, Svg18Question, Svg18Star1, Svg18Like1, Svg18Emoji1, Svg18DotG, Svg18Block1, Svg18TimeB, Svg18MessageC, Svg18AddB, Svg18RemoveB, Svg18PinB, Svg18NotionG, Svg18Website } from '@moim/icons';
import styled from 'styled-components';
import Url, { qs } from 'url-parse';

var SUPPORTED_ICON_SET = {
  "18_info": Svg18Info,
  "18_question": Svg18Question,
  "18_star": Svg18Star1,
  "18_heart": Svg18Like1,
  "18_smile": Svg18Emoji1,
  "18_dot": Svg18DotG,
  "18_box": Svg18Block1,
  "18_clock": Svg18TimeB,
  "18_chat": Svg18MessageC,
  "18_plus": Svg18AddB,
  "18_minus": Svg18RemoveB,
  "18_pin": Svg18PinB,
  "18_bell": Svg18NotionG,
  "18_globe": Svg18Website
};
var createStyledIcon = function createStyledIcon(iconName) {
  if (!iconName) {
    return null;
  }
  var Icon = SUPPORTED_ICON_SET[iconName];
  if (Icon) {
    return styled(Icon).attrs(function (props) {
      return {
        size: "xs",
        iconColor: props.colorKey ? props.theme.colorV2.colorSet[props.colorKey] : undefined
      };
    }).withConfig({
      componentId: "sc-107x587-0"
    })([""]);
  }
  return null;
};
var SUPPORTED_ICON_COMPONENT_SET = Object.keys(SUPPORTED_ICON_SET).reduce(function (result, current) {
  result[current] = createStyledIcon(current);
  return result;
}, {});
var ImageWithIcon = function ImageWithIcon(_ref) {
  var imageUrl = _ref.imageUrl,
    className = _ref.className,
    defaultIcon = _ref.defaultIcon;
  var _a;
  var url = new Url(imageUrl);
  if (url.protocol.startsWith("moimicon")) {
    var iconName = url.hostname;
    var options = qs.parse(url.query);
    var IconComponent = (_a = SUPPORTED_ICON_COMPONENT_SET[iconName]) !== null && _a !== void 0 ? _a : SUPPORTED_ICON_COMPONENT_SET[defaultIcon !== null && defaultIcon !== void 0 ? defaultIcon : ""];
    if (IconComponent) {
      return jsx(IconComponent, {
        colorKey: options.color
      });
    }
    return null;
  }
  return jsx("img", {
    className: className,
    src: url.href
  });
};

export { ImageWithIcon };
